import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../component/table/customize-table";
import LayoutTopIcon from "../../../component/icons/layout-top";
import Chip from "../../../component/ui/chip";
import ProjectQuickView from "../../projects/project/popup";
import Tooltip from "../../../component/ui/tooltip";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
  TableSort,
} from "../../../component/table/table-layout";
import NewEyeIcon from "../../../component/icons/action-eye-icon";
import LeadQuickView from "../../mainleads/leads/lead/popup";
import ContactQuickView from "../../mainAccounts/accounts/contact/popup";
import AccountQuickView from "../../mainAccounts/accounts/account/popup";
import DealQuickView from "../../mainDeals/deals/deal/popup";

const Logs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeader, setTableHeader] = useState([]);
  const [quickViewType, setQuickViewType] = useState(null);
  const [empData, setEmpData] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const [sortFields, setSortFields] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [selectFilterName, setSelectFilterName] = useState("My Filter");
  const [editingFilters, setEditingFilters] = useState(null);
  const [Total, setTotal] = useState(0);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
  }, []);

  const handleSingleSort = (field) => {
    setPageCount(1);
    setSortFields((prev) => {
      let currentSort = prev[0]; // Assume prev is an array with max 1 object
      let newSortField;
      if (currentSort && currentSort.field === field) {
        if (currentSort.order === "desc") {
          newSortField = { field, order: "asc" };
        } else if (currentSort.order === "asc") {
          newSortField = null;
        }
      } else {
        newSortField = { field, order: "desc" };
      }
      const finalSortFields = newSortField ? [newSortField] : [];
      // Trigger the filter with the updated sort
      filterData({ sortField: finalSortFields, page: 1 });
      return finalSortFields;
    });
  };

  const filterData = ({
    filters = filterReturn,
    page = pageCount,
    page_quantity = pageItemsCount,
    sortField = sortFields,
    btnCall = false,
  }) => {
    const sort_by = sortField[0]?.field || null;
    const sort_direction = sortField[0]?.order || null;
    const data = {
      page,
      page_quantity,
      filters,
      sort_by,
      sort_direction,
      btnCall,
    };
    getData(data);
  };

  const getData = async (data = null) => {
    if (data?.btnCall) {
      setBtnLoader(true);
    } else {
      setIsLoading(true);
    }
    let urlData = ``;
    if (data) {
      urlData = !data?.page
        ? `&page_quantity=10&page=1`
        : `&page=${data?.page}${
            data?.page_quantity !== "all"
              ? `&page_quantity=${data?.page_quantity}`
              : ""
          }`;
      if (data?.filters) {
        data?.filters.forEach((el) => {
          const key = el.field || el.name; // support both
          if (key === "date_filter" && el.value === "between") {
            if (el.startDate) {
              urlData += `&date_filter=custom&start_date=${el?.startDate}`;
            }
            if (el.endDate) {
              urlData += `&end_date=${el?.endDate}`;
            }
          } else if (el?.value !== "" && el?.value != null) {
            urlData += `&${key}=${el.value}`;
          }
        });
      }
      if (data?.sort_by && data?.sort_direction) {
        urlData += `&sort_by=${data.sort_by}&sort_direction=${data.sort_direction}`;
      }
    }

    try {
      let res = await apiCall({
        url: `activities/get-logs?scope=organization${urlData}`,
        method: "get",
      });
      if (data?.btnCall) {
        setBtnLoader(false);
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setTotal(res?.pagination?.total);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Err", error);
    }
  };

  const filterModalData = [
    {
      name: "date_filter",
      label: "By Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "This Week", value: "this_week" },
        { label: "This Month", value: "this_month" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
  ];

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody}`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              <TableFilterReturn
                filterReturn={filterReturn}
                onChange={(allFilter) => {
                  setFilterReturn(allFilter);

                  getData({ filter: allFilter });
                }}
              />

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  <div className={Style.bpfl_select}>
                    <select
                      onChange={(e) => {
                        filterData({
                          page_quantity: e?.target.value,
                          page: 1,
                        });

                        setPageCount(1);
                        setPageItemsCount(e?.target.value);
                      }}
                    >
                      <option value="10">Activity View 10</option>
                      <option value="25">Activity View 25</option>
                      <option value="50">Activity View 50</option>
                      <option value="100">Activity View 100</option>
                      <option value={Total}>Activity View all</option>
                    </select>
                  </div>
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          filterReturn?.length ? Style.active : null
                        }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <div className="flex justify-center items-center w-full h-full">
                    <DataNotFound title={"Activities"} />
                  </div>
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <TableHeaderWrap>
                                <span className="">User Details</span>
                                {false ? (
                                  <TableSort
                                    field="User Details"
                                    sortFields={sortFields}
                                    onSort={handleSingleSort}
                                    Style={Style}
                                  />
                                ) : (
                                  <TableSort
                                    disabled={true}
                                    field="User Details"
                                    Style={Style}
                                  />
                                )}
                              </TableHeaderWrap>
                            </TableCell>
                            <TableCell header>
                              <div className="flex gap-4 justify-between items-center">
                                <span>Email</span>

                                {true ? (
                                  <TableSort
                                    field="Email"
                                    sortFields={sortFields}
                                    onSort={handleSingleSort}
                                    Style={Style}
                                  />
                                ) : (
                                  <TableSort
                                    disabled={true}
                                    field="Email"
                                    Style={Style}
                                  />
                                )}
                              </div>
                            </TableCell>
                            <TableCell header>
                              <div className="flex gap-4 justify-between items-center">
                                <span>Phone</span>
                                {true ? (
                                  <TableSort
                                    field="Phone"
                                    sortFields={sortFields}
                                    onSort={handleSingleSort}
                                    Style={Style}
                                  />
                                ) : (
                                  <TableSort
                                    disabled={true}
                                    field="Phone"
                                    Style={Style}
                                  />
                                )}
                              </div>
                            </TableCell>
                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                              eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                    {eachHead?.sort_by ? (
                                      <TableSort
                                        field={eachHead?.key}
                                        sortFields={sortFields}
                                        onSort={handleSingleSort}
                                        Style={Style}
                                      />
                                    ) : (
                                      <TableSort
                                        disabled={true}
                                        field={eachHead?.key}
                                        Style={Style}
                                      />
                                    )}
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    {eachList?.entity?.contact_info ? (
                                      <>
                                        <div className="flex items-center gap-3">
                                          <div>
                                            {eachList?.entity?.contact_info
                                              ?.userimg ? (
                                              <img
                                                className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                                src={
                                                  eachList?.entity?.contact_info
                                                    ?.userimg
                                                }
                                                alt={
                                                  eachList?.entity?.contact_info
                                                    ?.name
                                                }
                                                onError={(e) => {
                                                  e.target.classList.add(
                                                    "hidden"
                                                  );
                                                  if (e.target.parentElement) {
                                                    e.target.parentElement.innerHTML = `
                                          <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                            ${
                                              eachList?.entity?.contact_info?.name?.split(
                                                " "
                                              )[0]?.[0] || ""
                                            }${
                                                      eachList?.entity?.contact_info?.name?.split(
                                                        " "
                                                      )[1]?.[0] || ""
                                                    }
                                          </div>`;
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                {eachList?.entity?.contact_info?.name?.split(
                                                  " "
                                                )[0]
                                                  ? eachList?.entity?.contact_info?.name?.split(
                                                      " "
                                                    )[0][0]
                                                  : ""}
                                                {eachList?.entity?.contact_info?.name?.split(
                                                  " "
                                                )[1]
                                                  ? eachList?.entity?.contact_info?.name?.split(
                                                      " "
                                                    )[1][0]
                                                  : ""}
                                              </div>
                                            )}
                                          </div>
                                          <div className="font-medium leading-5">
                                            {
                                              eachList?.entity?.contact_info
                                                ?.name
                                            }
                                          </div>
                                        </div>

                                        <div
                                          className={
                                            Style.tableActionAreaBtnGrpup
                                          }
                                        >
                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                            onClick={() => {
                                              setEmpData(eachList);
                                              setQuickViewType(
                                                eachList?.entity?.type
                                              );
                                            }}
                                          >
                                            <div
                                              className={Style.icon}
                                              style={{ color: "#007AFF" }}
                                            >
                                              <NewEyeIcon className="h-4.5 w-4.5" />
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </TableCell>
                                <TableCell>
                                  {eachList?.entity?.contact_info?.email ? (
                                    <a
                                      href={
                                        `mailto:${eachList?.entity?.contact_info?.email}` ||
                                        ""
                                      }
                                    >
                                      {eachList?.entity?.contact_info?.email ||
                                        "--"}
                                    </a>
                                  ) : (
                                    "--"
                                  )}
                                </TableCell>
                                <TableCell>
                                  {eachList?.entity?.contact_info?.phone ||
                                    "--"}
                                </TableCell>
                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 &&
                                  eachHead?.show == 1 ? (
                                    <>
                                      {eachHead.key === "user_type" ? (
                                        <TableCell key={`${i}-${index}`}>
                                          {eachList?.user_type === "Contact"
                                            ? "Lead"
                                            : eachList?.user_type}
                                        </TableCell>
                                      ) : eachHead?.key == "entity" ? (
                                        <TableCell
                                          key={`${i}-${index}`}
                                          className="capitalize text-center"
                                        >
                                          {eachList?.entity?.type == "lead" ? (
                                            <Chip color="orange">Lead</Chip>
                                          ) : eachList?.entity?.type ==
                                            "deal" ? (
                                            <Chip color="blue">Deal</Chip>
                                          ) : eachList?.entity?.type ==
                                            "contact" ? (
                                            <Chip color="green">Contact</Chip>
                                          ) : eachList?.entity?.type ==
                                            "account" ? (
                                            <Chip color="sky">Account</Chip>
                                          ) : eachList?.entity?.type ==
                                            "project" ? (
                                            <Chip color="blue">Project</Chip>
                                          ) : (
                                            <Chip color="gray">-</Chip>
                                          )}
                                        </TableCell>
                                      ) : eachHead.key === "user" ? (
                                        <>
                                          {eachList?.user ? (
                                            <TableCell key={`${i}-${index}`}>
                                              <div className="flex items-center gap-3">
                                                <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                  {eachList?.user?.userimg ? (
                                                    <img
                                                      src={`${eachList?.user?.userimg}`}
                                                      alt={eachList?.user?.name}
                                                      className="h-9 w-9 shrink-0 rounded-full object-cover object-center"
                                                      onError={(e) => {
                                                        e.target.classList.add(
                                                          "hidden"
                                                        );
                                                        if (
                                                          e.target.parentElement
                                                        ) {
                                                          e.target.parentElement.innerHTML = `
                                              <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                ${
                                                  eachList?.user?.name?.split(
                                                    " "
                                                  )[0]?.[0] || ""
                                                }${
                                                            eachList?.user?.name?.split(
                                                              " "
                                                            )[1]?.[0] || ""
                                                          }
                                              </div>`;
                                                        }
                                                      }}
                                                    />
                                                  ) : (
                                                    <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                      {eachList?.user?.name?.split(
                                                        " "
                                                      )[0]?.[0] || ""}
                                                      {eachList?.user?.name?.split(
                                                        " "
                                                      )[1]?.[0] || ""}
                                                    </div>
                                                  )}
                                                </div>
                                                <span className="font-medium">
                                                  {eachList?.user?.name || "-"}
                                                </span>
                                              </div>
                                            </TableCell>
                                          ) : (
                                            <TableCell key={`${i}-${index}`}>
                                              --
                                            </TableCell>
                                          )}
                                        </>
                                      ) : (
                                        <TableCell key={`${i}-${index}`}>
                                          {eachList[eachHead?.key] ?? "-"}
                                        </TableCell>
                                      )}
                                    </>
                                  ) : null
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>
              {/* FOOTER */}

              {!isLoading ? (
                apiData?.length > 0 ? (
                  <div
                    className={Style.table_footer}
                    style={{ alignItems: "center" }}
                  >
                    <div className={Style.table_footer_left}>
                      {`showing 1 to ${apiData?.length} of ${
                        tablePagination?.total || apiData?.length
                      }`}
                    </div>

                    {tablePagination ? (
                      <div className={Style.empDirectory_footer}>
                        {tablePagination?.next_page_url ? (
                          <button
                            className={Style.loadMoreBtn}
                            onClick={() => {
                              if (btnLoader) return;
                              setPageCount(pageCount + 1);
                              setBtnLoader(true);
                              filterData({
                                page: pageCount + 1,
                                btnCall: true,
                              });
                            }}
                          >
                            {btnLoader ? (
                              <InnerLoader
                                className={Style.loader}
                                textStatus={false}
                              />
                            ) : (
                              "Load More"
                            )}
                          </button>
                        ) : null}
                      </div>
                    ) : null}

                    <div
                      className={`${Style.table_footer_left} ${Style.rightText}`}
                    ></div>
                  </div>
                ) : null
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          saveFilter={saveFilter}
          apiUrl="get-logs"
          onSave={(filters, filterName, editingFilter) => {
            setShowModalFilterTable(false);
            setFilterReturn(filters ? filters : []);
            setSelectFilterName(filterName ? filterName : "My Filter");
            setEditingFilters(editingFilter ? editingFilter : []);
            setPageCount(1);
            filterData({ filters: filters, page: 1 });
          }}
          selectFilterName={selectFilterName}
          editingFilters={editingFilters}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="get-logs"
        />
      )}

      {quickViewType === "deal" && (
        <DealQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, dealid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "lead" && (
        <LeadQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, leadid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "contact" && (
        <ContactQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, userid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "account" && (
        <AccountQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, userid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "project" && (
        <ProjectQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, projectkey: empData?.entity?.data?.projectkey }}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Logs;
